import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import AlertItem from './AlertItem';
import SavingsTable from '~/app/common/apps/analyze/components/savings/SavingsTable';


class MoreExpensiveVendorAlert extends Component {
  render() {
    return (
      <AlertItem
        alert={this.props.alert}
        date={moment(this.props.alert.date).format('MMMM Do, YYYY')}
        icon='usd'
        title={(
          <div>
            <Link to={`/corporate/analyze/buyer/${this.props.alert.buyer.id}`}>
              {this.props.alert.buyer.name}
            </Link>
            {' '} has purchased from more expensive vendors resulting in a net loss of {' '}
            <strong className='u-colorRed'>
              {this.props.alert.value.total.formatMoney()}
            </strong>
          </div>
        )}
        content={(
          <SavingsTable
            includeExport={true}
            savings={this.props.alert.value.savings}
            buyer_id={this.props.alert.buyer.id}
          />
        )}
        {...this.props}
      />
    );
  }
}

// TODO: add is deleted to each individual alert item
MoreExpensiveVendorAlert.propsTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default MoreExpensiveVendorAlert;
